// extracted by mini-css-extract-plugin
module.exports = {"xs":"strip-unit(0)","sm":"strip-unit(640px)","md":"strip-unit(1024px)","lg":"strip-unit(1440px)","xl":"strip-unit(1650px)","headerHeight":"strip-unit(80px)"};